export const areFormFieldsDifferent = (value1: unknown, value2: unknown): boolean =>
  (value1 ?? null) !== (value2 ?? null);
